import { render } from "./modalTest.vue?vue&type=template&id=96940964"
import script from "./modalTest.vue?vue&type=script&lang=js"
export * from "./modalTest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__